export const LOGIN_LOADING = "login/loading";
export const LOGIN_SUCCESS = "login/success";
export const LOGIN_ERR = "login/error";
export const LOGOUT = "logout";
